import { useNavigate, useSearch } from '@tanstack/react-router';

import type { DashboardDateRange } from '@/components/dashboard/model';
import {
  dashboardRouteSearchSchema,
  parseDashboardRouteSearch,
  serializeDashboardRouteFilters,
} from '../../dashboard/dashboardRouteSearch';

export function usePublisherDashboardRouteFilters(detailsMode = false) {
  const navigate = useNavigate({
    from: detailsMode ? '/supply/publishers/$publisherId/details/overview' : '/p/$publisherId',
  });
  const search = useSearch({ strict: false });
  const { range } = parseDashboardRouteSearch(dashboardRouteSearchSchema(search));
  return {
    range,
    setRange: (nextRange: DashboardDateRange) => {
      void navigate({
        search: serializeDashboardRouteFilters({ range: nextRange }),
        replace: true,
      });
    },
  };
}
